import { DefaultTheme } from 'styled-components/dist/types'
import { getFlowableModalStyles, getFlowableWizardStyles, getFlowableTabsStyles } from './containersStyles'
import { getFlowableInputStyles, getFlowableButtonStyles } from './dataEntryAndSelectionStyles'
import { getFlowableAlertStyles, getFlowableDividerStyles, getFlowableTablesStyles } from './displayStyles'
import { getFlowablePageStyles } from './generalFlowableStyles'


export default function getFlowableStyles(props: { theme: DefaultTheme }): string {
  return `
    ${getFlowableModalStyles(props)}
    ${getFlowableWizardStyles(props)}
    ${getFlowableTabsStyles(props)}
    ${getFlowableInputStyles(props)}
    ${getFlowablePageStyles(props)}
    ${getFlowableAlertStyles(props)}
    ${getFlowableButtonStyles(props)}
    ${getFlowableDividerStyles(props)}
    ${getFlowableTablesStyles(props)}
  `
}
